// extracted by mini-css-extract-plugin
export var menuItem = "z_tK d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "z_tL d_Z d_bz d_bP";
export var menuMainLink = "z_tM d_f0 d_dB";
export var menuLink = "z_tN d_f0 d_dB";
export var icon = "z_p9 d_bC d_bP";
export var divider = "z_tP d_bC d_bP";
export var sublinks = "z_tQ";
export var link = "z_mC";
export var Link = "z_rv s_rv s_qM s_q5";